import convertCSTToLocal from "./convertCSTToLocal";

const formatDateForDetailsBox = (
	dateString: string | undefined,
	includeTime?: boolean
) => {
	// Check if dateString is undefined or null
	if (!dateString) {
		return "Invalid Date"; // or return a default message, or an empty string
	}

	const localDate = convertCSTToLocal(dateString);

	if (!localDate.isValid()) {
		return "Invalid Date Format";
	}

	if (includeTime) {
		return localDate.format("h:mma, MMM DD, YYYY");
	}

	return localDate.format("MMM DD, YYYY");
};

export default formatDateForDetailsBox;
